



export function mapSectionFieldsAndInitialInputs(sectionFields, initialInput) {
    // Don't accept initial inputs not in section fields to keep clean mappings only
    const mapped_initial_input = {}

    for (const key in initialInput) {
        if (key in sectionFields) {
            mapped_initial_input[key] = initialInput[key]
        }
    }

    return mapped_initial_input;
}


export function urlToLocalImageAsset(url) {
    if (url === 'https://efrt-public-assets.s3.amazonaws.com/medx_logo.png') {
        return '/assets/logo.png'
    } else {
        return '/assets/mcmaster_logo.png'
    }
}

